export default [{
  key: true,
  value: true,
  label: 'Free',
}, {
  key: false,
  value: false,
  label: 'Paid',
}];
